export default __webpack_public_path__ + "static/media/midswing.7ae53335.png";